import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { env } from '@/env';
import { isSupportedImageUrl } from '@/lib/media/image-support';
import type { UIMediaItem } from '@/types/ui-media';
import { mediaLogger } from './logger';
const enableMediaDebugLogging = env.NEXT_PUBLIC_TWEET_MEDIA_DEBUG ?? false;
function createMediaKey(media: UIMediaItem): string {
  return media.mediaKey || `${media.type}|${media.url || ''}|${media.previewImageUrl || ''}`;
}
export function useTweetMediaItems(mediaItems) {
  const $ = _c(2);
  let deduped;
  if ($[0] !== mediaItems) {
    const seen = new Set();
    deduped = [];
    for (const media of mediaItems) {
      if (!media) {
        continue;
      }
      if (media.type === "photo") {
        if (!media.url) {
          mediaLogger.warn("TweetMedia - Skipping photo without URL", {
            media
          });
          continue;
        }
        if (!isSupportedImageUrl(media.url)) {
          mediaLogger.warn("TweetMedia - Skipping unsupported image URL", {
            media
          });
          continue;
        }
      }
      const key = createMediaKey(media);
      if (seen.has(key)) {
        continue;
      }
      seen.add(key);
      deduped.push(media);
    }
    if (enableMediaDebugLogging) {
      mediaLogger.debug("TweetMedia - Media Items loaded", {
        count: deduped.length,
        items: deduped
      });
      for (const [index, item] of deduped.entries()) {
        if (item.type === "video" || item.type === "animated_gif") {
          mediaLogger.debug(`TweetMedia - Video ${index} details`, {
            type: item.type,
            hasUrl: Boolean(item.url),
            hasPreview: Boolean(item.previewImageUrl),
            url: item.url,
            variants: item.variants,
            mediaKey: item.mediaKey
          });
        }
      }
    }
    $[0] = mediaItems;
    $[1] = deduped;
  } else {
    deduped = $[1];
  }
  return deduped;
}